import React from 'react';

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      {...props}
    >
      <path
        d="M33 3C34.5977 3 35.9039 4.25068 35.9951 5.82715L36 6.00293V14.9863H42C43.5976 14.9863 44.9038 16.2361 44.9951 17.8125L45 17.9893V36.0078C45 37.607 43.7513 38.9143 42.1768 39.0059L42 39.0117H39V43.498C39 44.327 38.3125 45 37.4844 45C36.705 45 36.0779 44.4038 36.0068 43.6426L36 43.498L36.0078 39.0117H12V43.498C12 44.327 11.313 45 10.4844 45C9.7045 45 9.07787 44.4038 9.00684 43.6426L9 43.498L9.00781 39.0117H6C4.40231 39.0117 3.09613 37.761 3.00488 36.1846L3 36.0078V17.9893C3 16.3901 4.24866 15.0828 5.82324 14.9912L6 14.9863H12V6.00293C12.0001 4.40382 13.2487 3.09645 14.8232 3.00488L15 3H33ZM15.0029 36H33V30H15L15.0029 36ZM15 27H33V6H15V27Z"
        fill="#006FCF"
      />
    </svg>
  );
}

export default Icon;
